namespace GeniuzPOS.ReportMasterData {
    export class Report_1316Columns {
        static columnsKey = 'ReportMasterData.Report_1316';
    }
}
